// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const clobbopus: PokeData = {
  "id": 852,
  "name": "clobbopus",
  "height": 6,
  "weight": 40,
  "base_experience": 62,
  "types": [
    PokeType.FIGHTING
  ],
  "api_moves": [
    "bind",
    "leer",
    "submission",
    "reversal",
    "detect",
    "rock-smash",
    "taunt",
    "superpower",
    "brick-break",
    "bulk-up",
    "feint"
  ],
  "moves": [
    "leer",
    "rock-smash",
    "superpower",
    "bulk-up",
    "double-kick",
    "close-combat",
    "drain-punch",
    "karate-chop",
    "vacuum-wave",
    "coaching",
    "jump-kick",
    "meteor-assault",
    "rolling-kick"
  ],
  "evolution_chain": {
    "id": 448,
    "item": null,
    "species": [
      {
        "name": "clobbopus",
        "order": 852,
        "types": [
          PokeType.FIGHTING
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "grapploct",
        "order": 853,
        "types": [
          PokeType.FIGHTING
        ],
        "evolves_from_species_id": 852,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": {
              "name": "taunt"
            },
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 52.5,
    "speed": 32,
    "ability_power": 68
  },
  "stat_changes": [],
  "catch_rate": 180,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
